import { useQuery } from "@tanstack/react-query";
import { existByNickName } from "../../../../../service/nickName";

const useExistByNickName = (nickName: string, enabled?: boolean) => {
    const query = useQuery({
        queryKey: ['existByNickName'],
        queryFn: () => existByNickName(nickName),
        enabled: !!enabled,
        select: (res) => res.data,
    })

    return query;
}



export { useExistByNickName }